import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e1b7109"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "preloader"
}

import {LoaderIcon} from '@/components/atoms'
import { Preloader } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'AtomPreloader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(Preloader).getters.isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon))))
      ]))
    : _createCommentVNode("", true)
}
}

})